import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { GitCompare, X, ArrowRight } from "lucide-react";
import { useCompare } from "../context/CompareContext";

export default function CompareBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { items, remove, clear } = useCompare();

  if (items.length === 0 || location.pathname === "/compare") return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pointer-events-none">
      <div className="max-w-[1240px] mx-auto bg-[#16244F] text-white rounded-2xl shadow-2xl p-3 md:p-4 flex items-center gap-3 pointer-events-auto">
        <div className="hidden sm:flex items-center gap-2 text-[#F9B57C] font-head font-semibold px-2">
          <GitCompare size={18} /> Compare
        </div>
        <div className="flex-1 flex items-center gap-2 overflow-x-auto">
          {items.map((c) => (
            <div key={c.id} className="shrink-0 flex items-center gap-2 bg-white/10 rounded-lg pl-3 pr-2 py-1.5">
              <span className="text-sm font-medium whitespace-nowrap max-w-[160px] truncate">{c.course}</span>
              <button onClick={() => remove(c.id)} className="text-white/60 hover:text-white"><X size={15} /></button>
            </div>
          ))}
          <span className="text-xs text-white/50 whitespace-nowrap">{items.length}/3 selected</span>
        </div>
        <button onClick={clear} className="hidden md:inline text-sm text-white/60 hover:text-white px-2">Clear</button>
        <button
          onClick={() => navigate("/compare")}
          disabled={items.length < 2}
          className="inline-flex items-center gap-2 bg-[#F58220] hover:bg-[#e0730f] disabled:opacity-50 text-white font-head font-semibold px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap"
        >
          Compare <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}
